/* eslint-disable react/destructuring-assignment */
import { ActionIcon, Group, Tooltip } from '@mantine/core';
import { IconEdit } from '@tabler/icons-react';
import { ItemToleranceType } from '../../../../models/core/core.type';
import theme from '../../../../theme';
import DeleteConfirmPopover from '../../../DeleteConfirmPopover';

type DataViewActionProps = {
  item: ItemToleranceType;
  confirmActionResult(item: ItemToleranceType | null, action: string, confirmed: boolean): void;
  // eslint-disable-next-line react/no-unused-prop-types
  zIndex: number;
};

export default function ToleranceFormViewActions(props: DataViewActionProps) {
  return (
    <div>
      <Group>
        <Tooltip
          withArrow
          transitionProps={{ transition: 'fade', duration: 200 }}
          label="Editar"
          zIndex={props.zIndex + 1}
        >
          <ActionIcon
            size="sm"
            color="primary"
            style={{ borderColor: theme?.colors?.accent?.[6] }}
            variant="outline"
            onClick={() => {
              props.confirmActionResult(props.item, 'editar', true);
            }}
          >
            <IconEdit size={15} color={theme?.colors?.accent?.[6]} />
          </ActionIcon>
        </Tooltip>
        <DeleteConfirmPopover
          label="Excluir"
          message="Esta ação removerá a tolerância."
          variant="outline"
          zIndex={props.zIndex + 1}
          onConfirm={() => {
            props.confirmActionResult(props.item, 'excluir', true);
          }}
          onCancel={() => {
            props.confirmActionResult(props.item, 'excluir', false);
          }}
        />
      </Group>
    </div>
  );
}
